import React, { useEffect, useState } from "react";
import AppButton from "component/button/AppButton";
import DocumentInput from "component/documentInputs/DocumentInput";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import styles from "./DocumentUpload.module.css";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";

import AppBackdrop from "component/appBackdrop/AppBackdrop";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { docuementUploadSchmea } from "schemas/Documents/DocumentsSchemas";
import { useUploadDocument } from "api/mutations/documents";
import { useCheckDocuments } from "api/queries/dashboard/docuements/Documents";
import documents from "utils/documents";

import { useNavigate } from "react-router";

function DocumentUpload({ onClose }) {
  const [image, setImage] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [requiredDocuments, setReiquiredDocuments] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(docuementUploadSchmea) });

  const { mutate, isLoading, openModal, setOpenModal } = useUploadDocument();

  const { documentsCheckData, loading } = useCheckDocuments();

  useEffect(() => {
    if (documentsCheckData?.requiredDocuments?.length > 0) {
      setReiquiredDocuments(
        documents?.filter((doc) =>
          documentsCheckData?.requiredDocuments?.includes(doc?.value)
        )
      );
    }
  }, [documentsCheckData]);

  const submitDoc = (data) => {
    setFileError(null);
    if (!image) {
      setFileError("File is required");
    } else {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("type", data?.type);
      mutate(formData);
    }
  };

  return (
    <div className={styles.document_upload}>
      <div className={styles.field}>
        <LabeledSelect
          name="type"
          data={requiredDocuments}
          register={register}
          errors={errors}
          label="Document"
          placeholder="Select Document"
        />
      </div>
      
      <div className={styles.field}>
        <DocumentInput
          image={image}
          setImage={setImage}
          fileError={fileError}
          setFileError={setFileError}
        />
      </div>
      <div className={styles.btn}>
        <AppButton
          fullwidth
          handleAction={handleSubmit(submitDoc)}
          width={"189px"}
          textColor="#FFFFFF"
          btnBg="#0089FF"
          btnText="Upload Document"
          loading={isLoading}
        />
      </div>
      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              onClose();
              setImage(null);
            }}
            icon={'success'}
            primaryText="Success"
            secondaryText="Your document has been uploaded successfully"
          />
        }
      />
      
    </div>
  );
}

export default DocumentUpload;
